




































import Vue from "vue";
import { ARadio } from "@canvas/componentlibrary";
import InActive from "../Project/InActive.vue";
import ActiveProjectDetails from "./ActiveProjectDetails.vue";
import OnHold from "../Project/OnHold.vue";

export default Vue.extend({
  components: {
    ARadio,
    InActive,
    OnHold,
    ActiveProjectDetails,
  },
  data(): { [key: string]: any } {
    return {
      orderType: "Active",
    };
  },
  methods: {
    handleInput(event: { value: any; checked: boolean }) {
      this.orderType = event.value;
    },
  },
});
